export const API_USER = '/user';
export const API_USER_USERNAME = '/user/username';
export const API_USER_EMAIL = '/user/email';
export const API_USER_PASSWORD = '/user/password';
export const API_PHONE_CHANGE_REQUEST = '/phone-numbers/change-request';
export const API_PHONE_CREATION_REQUEST = '/phone-numbers/creation-request';
export const API_USER_TERMS_AND_CONDITIONS_ACCEPT =
  '/user/terms-and-conditions/accept';
export const API_STUDENT_JOIN_OFFERS = '/student-join-offers';
export const API_STUDENT_JOIN_OFFERS_REMIND_LATER =
  '/student-join-offers/remind-later';
export const API_STUDENT_JOIN_OFFERS_DECLINE = '/student-join-offers/decline';
export const API_FAMILY_MEMBERS = '/family-members';
export const API_FAMILY_SETTINGS = '/family-members/current-student/settings';
export const API_USER_PROFILES_BY_YEAR = '/user/profiles/by-year';
export const API_USER_PROFILES_SYNC = '/user/profiles/sync';
export const API_USER_PROFILES_SWITCH = '/user/profiles/switch';
export const API_USER_UNSEEN_EVENTS = '/user-unseen-events';
export const API_USER_UNSEEN_EVENTS_RESET = '/user-unseen-events/reset';
export const API_TECHNICAL_SUPPORT = '/technical-support';
export const API_NEWS = '/news';
export const API_GALLERIES = '/galleries';
export const API_ATTACHMENTS = '/attachments';
export const API_NOTICE = '/dashboard-advertisement-messages';
export const API_NOTICE_HIDE = '/dashboard-advertisement-messages/hide';
export const API_TEACHER_MESSAGES = '/teacher-messages';
export const API_EVALUATIONS = '/evaluations';
export const API_TEST_REPORTS = '/test-reports';
export const API_EVALUATIONS_SUMMARY = '/evaluations/summary';
export const API_LESSON_TYPES_CURRENT_STUDENT = '/lesson-types/current-student';
export const API_EVALUATION_RATINGS = '/evaluation-ratings';
export const API_SAME_LEVEL_CLASSES = '/classes/same-level';
export const API_EVALUATION_REPORTS = '/evaluation-reports';
export const API_EVALUATION_REPORTS_FINAL =
  '/evaluation-reports/final-evaluations';
export const API_INDIVIDUAL_SUPPORT_PLANS_ACKNOWLEDGE =
  '/individual-support-plans/acknowledge';
export const API_PRESCHOOL_EDUCATION_PLANS = '/preschool-education-plans';
export const API_PRESCHOOL_EVALUATIONS = '/preschool-special-needs-evaluations';
export const API_PRESCHOOL_EVALUATIONS_APPROVE =
  '/preschool-special-needs-evaluations/approve';
export const API_NON_ATTENDANCE_APPLICATIONS = '/non-attendance-applications';
export const API_NON_ATTENDANCE_APPLICATIONS_PROPERTIES =
  '/non-attendance-applications/properties';
export const API_NON_ATTENDANCE_STATISTICS = '/non-attendances/statistics';
export const API_STUDY_YEAR_PERIODS = '/study-year-periods';
export const API_ABSENCE_EXCUSES = '/absence-excuses';
export const API_PAYMENT_OPTIONS = '/payment-options';
export const API_SMS_PAYMENTS = '/sms-payments';
export const API_BANK_PAYMENTS_START = '/bank-payments/start';
export const API_SUBSCRIPTION_SMS_CANCEL =
  '/user-settings/subscription-payments/sms/cancel';
export const API_SUBSCRIPTION_CARD_CANCEL =
  '/user-settings/subscription-payments/card/cancel';
export const API_USER_SETTINGS_ADS = '/user-settings/ads';
export const API_USER_SETTINGS_COMMERCIAL_NEWS =
  '/user-settings/commercial-news';
export const API_USER_SETTINGS_NOTIFICATIONS = '/user-settings/notifications';
export const API_TEST_SCHEDULES = '/test-schedules';
export const API_LESSON_TIMES = '/lesson-times';
export const API_MAIL_FOLDERS = '/mail/folders';
export const API_MAIL_MESSAGE_IDS = '/mail/message-ids';
export const API_MAIL_MESSAGES = '/mail/messages';
export const API_MAIL_MESSAGES_READ = '/mail/messages/read';
export const API_MAIL_MESSAGES_READ_ALL = '/mail/messages/read-all';
export const API_MAIL_MESSAGES_DELETE_PERMANENTLY =
  '/mail/messages/delete-permanently';
export const API_MAIL_RECIPIENT_GROUPS = '/mail/recipient-groups';
export const API_SURVEYS = '/surveys';
export const API_SURVEY_QUESTIONS = '/survey-questions';
export const API_VIDEO_MEETINGS = '/video-meetings';
export const API_LINKS = '/links';
export const API_LINKS_TOKENIZE = '/links/tokenize';
export const API_DIARY = '/diary';
export const API_HOME_TASKS = '/home-tasks';
export const API_JOURNALS = '/journals';
export const API_JOURNAL_REPORTS = '/journal-reports';
export const API_THIRD_PARTY_EVENTS = '/third-party-events';
